<ul class="kt-sticky-toolbar" style="margin-top: 30px;">
		<li class="kt-sticky-toolbar__item kt-sticky-toolbar__item--success" data-toggle="kt-tooltip" title="Data Compliances">
			<a routerLink="/datacompliances" class=""><i class="flaticon2-drop"></i></a>
		</li>
		<li class="kt-sticky-toolbar__item kt-sticky-toolbar__item--brand" data-toggle="kt-tooltip" title="Terms & Conditions">
			<a href="#" target="_blank"><i class="flaticon2-gear"></i></a>
		</li>
		<li class="kt-sticky-toolbar__item kt-sticky-toolbar__item--warning" data-toggle="kt-tooltip" title="Privacy Policy">
			<a href="#" target="_blank"><i class="flaticon2-telegram-logo"></i></a>
		</li>
		<li class="kt-sticky-toolbar__item kt-sticky-toolbar__item--danger" data-toggle="kt-tooltip" title="Data Alerts">
			<a href="#"><i class="flaticon2-chat-1"></i></a>
		</li>
	</ul>
